<template>
    <MyModal ref="myModalRef" title="投诉查看" width="1200px" height="700px">
      <div class="detail-box-uniq-1232311">
        <div class="detail-main-info">
          <MyTitle title="基本信息" :mt0="true" />
          <el-descriptions v-if="1" :column="2" border style="width: 100%">
            <el-descriptions-item label="投诉编号" label-align="right" align="left" :span="2">{{ complaintInfo.complaintCode }}</el-descriptions-item>
            <el-descriptions-item label="企业名称" label-align="right" align="left" :span="2">{{ complaintInfo.comName }}</el-descriptions-item>
            <el-descriptions-item label="所属单位" label-align="right" align="left" :span="2">{{ complaintInfo.streetName }}</el-descriptions-item>
            <el-descriptions-item label="投诉人姓名" label-align="right" align="left" :span="1">{{ complaintInfo.userName }}</el-descriptions-item>
            <el-descriptions-item label="联系方式" label-align="right" align="left" :span="1">{{ complaintInfo.userPhone }}</el-descriptions-item>
            <el-descriptions-item label="欠薪金额" label-align="right" align="left" :span="2">{{ complaintInfo.arrearsAmount }}<span v-if="complaintInfo.arrearsAmount">元</span></el-descriptions-item>
            <el-descriptions-item label="欠薪期间" label-align="right" align="left" :span="2">{{ complaintInfo.wageArrearsStart }} <span style="margin: 0 6px">至</span> {{ complaintInfo.wageArrearsEnd }}</el-descriptions-item>
            <el-descriptions-item label="备注/补充说明" label-align="right" align="left" :span="2">{{ complaintInfo.complaintExplain }}</el-descriptions-item>
            <el-descriptions-item label="附件" label-align="right" align="left" :span="2">
              <MyFileList :fileList="complaintInfo.fileUrl" :columns="7"></MyFileList>
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <div class="detail-log-flow">
          <MyTitle title="处置信息" :mt0="true" marginLeft="0px" />
          <MyTimeLine :cardList="recordList" :complaintInfo="complaintCopy" @handleUpdateData="handleOpen(complaintCopy)"></MyTimeLine>
        </div>
      </div>
      <template slot="footer">
        <el-button @click="handleClose">关闭</el-button>
      </template>
    </MyModal>
  </template>
  
  <script>
  import MyModal from "@/components/myComponents/MyModal/index.vue";
  import MyTitle from "@/components/myComponents/MyTitle/index.vue";
  import MyTimeLine from "@/components/myComponents/MyTimeLine/index.vue";
  import MyFileList from "@/components/myComponents/MyFileList/index.vue";
  import {getEnterpriseDetail, getRecodList} from "@/api/unpaidWages/enterprise";
  
  export default {
    name: 'ExceptionDetailModal',
    components: {
      MyModal,
      MyTitle,
      MyTimeLine,
      MyFileList
    },
    data() {
      return {
        complaintInfo: {},
        complaintCopy: {},
        recordList: []
      }
    },
    methods: {
      async handleOpen(complaint) {
        console.log(complaint,'complaint')
        try {
          // 确保 complaint 参数有效
          if (!complaint || !complaint.id) {
            console.error('投诉信息无效，无法打开详情');
            return;
          }
          
          this.complaintCopy = complaint || {};
          const complaintId = complaint.id;
          
          // 获取recordList 和基本信息
          const res = await getRecodList({complaintId: complaintId});
          // 确保 recordList 能正确处理响应结构
          const recordData = res?.data?.data || res?.data || [];
          this.recordList = (Array.isArray(recordData) ? recordData : []).map((item) => {
            return {
              ...item,
              fileList: !item.recordFileList || !item.recordFileList.length ? [] : item.recordFileList.map((file) => {
                if (typeof file === "object") return file;
                return {
                  fileName: file.split("/")[file.split("/").length - 1],
                  fileUrl: file,
                  path: file
                }
              })
            }
          });

          const complaintRes = await getEnterpriseDetail({id: complaintId});
          // 确保 complaintInfo 始终是一个对象，避免 undefined 错误
          this.complaintInfo = complaintRes?.data || {};

          this.$refs.myModalRef.handleOpen();
        } catch (error) {
          console.error('打开详情失败:', error);
        }
      },

      handleClose() {
        this.$refs.myModalRef.handleClose();
      },

      handleDirectlyClose() {
        this.$refs.myModalRef.handleDirectlyClose();
      }
    }
  }
  </script>
  
  <style lang="scss">
  .detail-box-uniq-1232311 {
    display: flex;
    height: fit-content;

    .detail-main-info {
      width: 646px;
      margin-right: 44px;
    }

    .detail-log-flow {
      flex: 1;
      height: auto;
      display: flex;
      flex-direction: column;
    }
    .el-descriptions__label {
      width: 120px;
      background-color: rgb(237, 246, 252)!important;
    }
    .el-descriptions__content {
      background-color: rgb(249, 250, 251)!important;
    }
  }
  </style>
